﻿function getBodyHeight() {
  var el = document.body;
  var height = el.offsetHeight;
  var style = getComputedStyle(el);

  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
}

function resizeWidget() {
  var actualHeight = getBodyHeight();
  var iframeName = window.name;

  if (window.parent.postMessage) {
    window.parent.postMessage(
      { action: "resizeIframe", height: actualHeight, name: iframeName },
      "*"
    );
  }
}

function sendMessage(action, jobId) {
    var iframeName = window.name;
    window.parent.postMessage(
        { action: action, jobId: jobId, name: iframeName, url: window.location.href },
    "*"
  );
}

function initialize() {
  if (window.__action == "Index") sendMessage("viewList", null);

  if (window.__action == "Job") {
    var jobId = document.querySelector("#JobId").value;
    sendMessage("viewJob", jobId);
  }

  if (window.addEventListener) {
    window.addEventListener("message", messageReceived, false);
  } else if (window.attachEvent) {
    window.attachEvent("onmessage", messageReceived);
  }

  function messageReceived(e) {
    var action = e.data.action;

    if (action == "updateListUrl") {
      var newListUrl = e.data.listUrl;
      var backElement = document.querySelector(".back-link");
      backElement.setAttribute("href", newListUrl);
    }
  }
}

export { resizeWidget, initialize, sendMessage };
